var render = function render(){var _vm=this,_c=_vm._self._c;return _c('base-select',{attrs:{"expand":"","shadow":false,"options":_vm.productPriceOptions},on:{"change":function($event){return _vm.$emit('change', _vm.selected)}},model:{value:(_vm.selected),callback:function ($$v) {_vm.selected=$$v},expression:"selected"}})
}
var staticRenderFns = []

export { render, staticRenderFns }